import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import { getTripLedgerData, getShopKhataData } from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing'
import ActionIconButton from '../../components/Actions/ActionIconButton';
import EditIcon from '@material-ui/icons/Edit';
import ColumnActions from '../../components/Actions/ColumnActions';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { trackDwebEvent } from '../../analytics';
import { ShopKhataEmptyStateIcon } from '../../../components/icons';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import DeleteIcon from '@material-ui/icons/Delete';
import AddShop from './AddShop';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo,defaultPageSize,defaultDebounceMs } from '../../../paginationVariables';
const Shops = ({ user, dispatchGetShopsDataAction }) => {
    const classes = useStyles();
    let history = useHistory();
    const [searchText, setSearchText] = useState("");
    const [currentPageNo,setCurrentPageNo]  = useState(defaultPageNo);
    const [currentPageSize,setCurrentPageSize]  = useState(defaultPageSize);
    const [shopKhataData, setShopKhataData] = useState([]);
    const [initialEmpty, setInitialEmpty] = useState(false);
    const [addShopOpen, setAddShopOpen] = useState(false);
    useEffect(() => {
        trackDwebEvent('Dweb Shop Khata page', {});
    }, []);
    const shopsReqData = {
        //pageNo: defaultPageNo,
        //pageSize: defaultPageSize,
        searchText: searchText
    };
    useEffect(() => {

        dispatchGetShopsDataAction(shopsReqData, (data) => {
            if (data && data.status && data.status.code == 200 && data.response && data.response.length <= 0) {
                setInitialEmpty(true)
            } else {
                setInitialEmpty(false)
            }
        });

    }, [dispatchGetShopsDataAction]);

    const onSearchBlur = debounce(query => {
        //setCurrentPageNo(defaultPageNo)
        dispatchGetShopsDataAction({ ...shopsReqData, searchText: query }, () => {

        })
    }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);

    const getPaginatedData =()=>{
        const shopsReqData = {
            pageNo: currentPageNo+1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge:true
        };
        dispatchGetShopsDataAction(shopsReqData, () => {

        })
    }

    useEffect(() => {

        if (user && user.shopsData) {
            if (initialEmpty && user.shopsData.length > 0) {
                setInitialEmpty(false)
            }
            setShopKhataData(user.shopsData);
            /*if (user.shopsData.length <= 0) {
                setInitialEmpty(true)
            } else {
                setInitialEmpty(false)
            }*/
        }
    }, [user.shopsData]);

    const handleTransactionRow = (index) => {
        if (index == 0 || index) {
            const shopId = shopKhataData[index].id;
            const shopName = shopKhataData[index].name;
            const balance = shopKhataData[index].balance;
            const number = shopKhataData[index].contactNumber;
            history.push({
                pathname: `/shops/shop/${shopId}`,
                state: {
                    id: shopId,
                    shopBalance: balance || null,
                    pageTitle: shopName ? shopName : 'Shop View',
                    shopName: shopName ? shopName : '',
                    shopNumber: number ? number : "",
                    shopId: shopId
                }
            });
        }
    }
    const handleAddShopClick = () => {
        setAddShopOpen(true);
    }
    const handleAddShopModalClose = (status) => {
        setAddShopOpen(status);
    }
    const handleShopSave = (status) => {
        dispatchGetShopsDataAction(searchText, (data) => {
            if (data && data.status && data.status.code == 200 && data.response && data.response.length <= 0) {
                setInitialEmpty(true)
            } else {
                setInitialEmpty(false)
            }
        })
    }
    const muiData = shopKhataData;
    const muiColumns = [
        {
            name: "name",
            label: "Shop Name",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = shopKhataData[dataIndex];
                    /*if (rowIndex === muiData.length - 3) {
                        return (
                        <>
                            <Waypoint
                            onEnter={() => {
                                if(user && !user.shopsEmpty){
                                    getPaginatedData()
                                    setCurrentPageNo(currentPageNo+1)
                                }
                            }}
                            />
                            <div className={classes.nameDivIcon}>
                                    {data.name}
                            </div>
                        </>
                        );
                    } else {*/
                        return (
                            <>
                                <div className={classes.nameDivIcon}>
                                    {data.name}
                                </div>
                            </>
                        )
                    /*}*/
                }
            },
        },
        {
            name: "contactNumber",
            label: "Shop Number",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span className={classes.fw300}>{value ? "+91 " + value : "N/A"}</span>
                }
            },
        },
        {
            name: "balance",
            label: "Shop Balance",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = shopKhataData[dataIndex];
                    return (
                        <>
                            <div className={classes.shopBalanceDiv}>
                                {data && data.balance
                                    && data.balance < 0 ? <>
                                    <Typography className={classes.shopBalanceDue}>{numberFormat(Math.abs(data.balance))}</Typography>
                                    <FiberManualRecordIcon className={classes.dotSeperator} />
                                    <Typography className={classes.shopBalanceDesc}>DUE</Typography>
                                </> : data && data.balance
                                    && data.balance > 0 ? <>
                                    <Typography className={classes.shopBalanceAdvance}>{numberFormat(data.balance)}</Typography>
                                    <FiberManualRecordIcon className={classes.dotSeperator} />
                                    <Typography className={classes.shopBalanceDesc}>ADVANCE</Typography>
                                </> : <>
                                    <Typography className={classes.shopBalance}>{numberFormat(data.balance)}</Typography>
                                </>
                                }
                            </div>
                        </>
                    )
                }
            },
        }/*,
      {
          name: "dateDisplay",
          label: "Action",
          options: {
              filter: true,
              sort: false,
              customBodyRender: (value) => {
                  return (
                      <div className={classes.shopActions}>
                          <Button><EditIcon /></Button>
                          <Button><DeleteIcon /></Button>
                      </div>
                  )
              }
          },
      }*/
    ];
    const options = {
        rowsPerPage: 100,
        pagination:true,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tripTableHeight,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleTransactionRow(rowMeta.dataIndex);
        },
        customToolbar: (data) => {
            return <>
                {/* <Button variant="contained" classes={{ root: classes.addPartyCta, label: classes.label, }} color="primary" onClick={handleAddPartyClick}>
                  <AddIcon /> Add Vehicle
              </Button>
              <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={goToTrip}>
                  <AddIcon /> Add Trip
              </Button> */}
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            // value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search for a Shop',
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            }else{
                setSearchText("");
                onSearchBlur("")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;

            return true;
        },
        textLabels: {
            body: {
                noMatch: "No Data found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };
    return (<Wrapper>
        <Paper className={classes.pageContentDIvTrip} elevation={3}>
            {initialEmpty ? <div className={classes.listEmptyState}>
                <img className={classes.listEmptyStateImgShop} src={`${process.env.PUBLIC_URL}/assets/images/empty-state-shops.svg`} alt={"Transport Footer"} />
                <Typography className={classes.listEmptyStateDesc} >
                    Add diesel pump, mechanic etc <br />and start managing your khata with them
                </Typography>
                <div className={classes.listEmptyStateActions}>
                    <Button variant="contained" className={classes.addShopCta} onClick={handleAddShopClick} >
                        <AddIcon /> Add Shop
                    </Button>
                </div>
            </div> : <div className={classes.shopTable}>
                <MUIDataTable title={""} className={classes.onlinePaymentsTable} data={muiData} columns={muiColumns} options={options} />
            </div>}
            {addShopOpen && <AddShop open={addShopOpen} onClose={handleAddShopModalClose} onSave={handleShopSave} />}
        </Paper>
    </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetShopsDataAction: (requestData, onSuccess, onFailure) =>
        dispatch(
            getShopKhataData(
                requestData,
                (data) => {
                    //trackDwebEvent('Dweb Shop Khata Page', {});
                    logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
                    if (onSuccess) {
                        onSuccess(data);
                    }
                },
                () => {
                    logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
                }
            )
        ),
});
const ShopsWithRouter = withRouter(Shops);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShopsWithRouter);
